export enum AccountPermission {
    WRITE = 'WRITE',
    READ = 'READ',
    OFF = 'OFF'
}

export const ACCOUNT_PERMISSIONS_NAMING: Record<AccountPermission, string> = {
    [AccountPermission.WRITE]: 'enums.account-permissions.write',
    [AccountPermission.READ]: 'enums.account-permissions.read',
    [AccountPermission.OFF]: 'enums.account-permissions.off'
};
